module.exports = __webpack_public_path__ + "img/add.2d5b9e3c.svg";